import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import {
  GetSessionsReportPayload,
  GetSensorsDataReportPayload,
  GetDetailedSensorsDataReportPayload,
  GetDetailedUnfilteredSensorsDataReportPayload,
} from "../interfaces";

export default {
  sessionsReports: (payload: GetSessionsReportPayload) => {
    const { hospital_id, ...rest } = payload;
    return request(METHODS.GET, API.REPORT.SESSIONS_REPORT(String(hospital_id)))({ params: rest });
  },
  sensorsDataReports: (payload: GetSensorsDataReportPayload) => {
    const { hospital_id, ...rest } = payload;
    return request(METHODS.GET, API.REPORT.SENSORS_DATA_REPORT(String(hospital_id)))({ params: rest });
  },
  sensorsDetailedDataReports: (payload: GetDetailedSensorsDataReportPayload) => {
    const { hospital_id, ...rest } = payload;
    return request(METHODS.GET, API.REPORT.DETAILED_SENSORS_DATA_REPORT(String(hospital_id)))({ params: rest });
  },
  sensorsDetailedUnfilteredDataReports: (payload: GetDetailedUnfilteredSensorsDataReportPayload) => {
    const { hospital_id, ...rest } = payload;
    return request(
      METHODS.GET,
      API.REPORT.DETAILED_UNFILTERED_SENSORS_DATA_REPORT(String(hospital_id)),
    )({ params: rest });
  },
};
